import React, { useEffect } from 'react';

export default function SplashView(props) {
  return (
    <div className="full-page-loader">
      <img width="53" src="/squared_logo.png" alt="ManageMyPain Logo" />
    </div>
  );
}
